<template>
  <full-page-modal
    :visible="visible"
    :footer="false"
    :confirm-loading="confirmLoading"
    :class="{ isEnglish: $isEnglish }"
  >
    <div
      slot="title"
      class="cube-picker-title-group"
    >
      <div
        class="left"
        @click="handleCancel"
      >
        <i class="iconfont iconicon-test40" />{{ $t('message["282"]') }}
      </div>
      <h1>{{ setVisitTit }}</h1>
    </div>
    <div slot="content">
      <cube-form
        :model="model"
        @submit.prevent="submitHandler"
        @validate="validateHandler"
      >
        <cube-form-item :field="fields[0]">
          <div
            class="date-time"
            :class="{'fs-gray': !model.time}"
            @click="showDatePicker"
          >
            {{ model.time || $t('message["855"]') }}
          </div>
        </cube-form-item>
        <cube-form-group>
          <cube-form-item
            :field="fields[1]"
            class="texarea"
          />
        </cube-form-group>
        <cube-form-group class="cube-picker-footer footer form-btn-box">
          <cube-button
            type="reset"
            class="cancel-btn cube-btn-light"
            @click="handleCancel"
          >
            {{ $t('message["896"]') }}
          </cube-button>
          <cube-button
            type="submit"
            class="confirm-btn cube-btn-primary"
          >
            {{ $t('message["915"]') }}
          </cube-button>
        </cube-form-group>
      </cube-form>
    </div>
  </full-page-modal>
</template>

<script>
import { mapActions } from 'vuex'
import eventBus from '@/lib/eventBus'
import FullPageModal from '@/components/mobile/FullPageModal'

export default {
  components: {
    FullPageModal
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    inquiryId: {
      type: [String, Number],
      default: () => { }
    },
    dataRemind: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      confirmLoading: false,
      dateSegmentPicker: null,
      model: {
        time: '',
        content: ''
      },
      fields: [
        {
          type: 'input',
          modelKey: 'time',
          label: this.$t('message["447"]'),
          props: {
            placeholder: this.$t('message["877"]')
          },
          rules: {
            required: true
          },
          messages: {
            required: this.$t('message["877"]')
          }
        },
        {
          type: 'textarea',
          modelKey: 'content',
          label: this.$t('message["1183"]'),
          props: {
            indicator: false,
            remain: false,
            maxlength: 10000000000,
            autoExpand: false,
            placeholder: this.$t('message["809"]')
          },
          rules: {
            required: true
          },
          messages: {
            required: this.$t('message["809"]')
          }
        }
      ]

    }
  },
  computed: {
    setVisitTit () {
      return this.$t('message["1027"]')
    },
    dateSegmentData () {
      const dateSegmentData = [
        {
          is: 'cube-date-picker',
          title: this.$t('message["1418"]'),
          // format: 'YYYY-MM-DD',
          // min: new Date(),
          max: new Date(2030, 11, 31)
        },
        {
          day: {
            len: 10
          },
          showNow: false,
          // format: 'hh:mm',
          is: 'cube-time-picker',
          title: this.$t('message["1419"]'),
          max: new Date(2030, 11, 31)
        }
      ]
      return dateSegmentData
    },
    tab () {
      return this.$route.query.tab || ''
    }
  },

  mounted () {
    eventBus.$on('setRemindModalData', (value) => {
      /* const { time = '', content = '' } = value || {}
      this.model.time = time
      this.model.content = content */
      this.setDefaultData(value)
    })
  },
  methods: {
    ...mapActions('inquery/detailData', ['inquiryAddRemind']),
    hide () {
      this.$emit('update:visible', false)
    },
    show () {
      this.$emit('update:visible', true)
    },
    showDatePicker () {
      this.datePicker.show()
    },
    setDefaultData (data) {
      const { time = '', content = '' } = data || {}
      const date = time.split(' ')[0]
      this.model.time = time
      this.model.content = content
      this.dateSegmentData[0].selectedIndex = date
      this.dateSegmentData[1].selectedIndex = time

      if (!this.datePicker) {
        this.datePicker = this.$createDatePicker({
          title: this.$t('message["1418"]'),
          format: {
            year: 'YYYY ' + this.$t('message["668"]'),
            month: 'MM ' + this.$t('message["1531"]'),
            date: 'DD ' + this.$t('message["941"]'),
            hour: 'hh ' + this.$t('message["1068"]'),
            minute: 'mm ' + this.$t('message["291"]')
          },
          min: new Date(2010, 11, 31),
          max: new Date(2030, 11, 31),
          value: this.model.time ? new Date(this.model.time) : new Date(),
          columnCount: 5,
          onSelect: (date, selectedVal, selectedText) => {
            let text = ''
            this.date = selectedText.map((item, i) => {
              if (i < 2) {
                text += item.split(' ')[0] + '-'
              } else if (i === 2) {
                text += item.split(' ')[0] + ' '
              } else if (i < 4) {
                text += item.split(' ')[0] + ':'
              } else if (i === 4) {
                text += item.split(' ')[0]
              }
            })

            this.model.time = text
          },
          onCancel: () => {
          }
        })
      }
    },
    validateHandler (result) {
      this.validity = result.validity
      this.valid = result.valid
    },
    async confirmData () {
      const params = {
        inquiryid: this.inquiryId,
        time: this.model.time,
        content: this.model.content
      }

      const chain = await this.inquiryAddRemind(params)
      chain
        .params(params)
        // .onSuccess(res => {
        // eventBus.$emit('fetchInquiryDetail')
        // })
        .fetch()
    },
    async submitHandler (e) {
      if (this.tab === 'addFollowup') {
        this.$bus.$emit('setRemind', {
          time: this.model.time,
          content: this.model.content
        })
      } else {
        await this.confirmData()
      }
      this.handleCancel()
    },
    handleCancel () {
      this.hide()
      this.confirmLoading = false
    }

  }
}
</script>

<style lang="scss" scoped>
.fullpage-modal {
  .cube-picker-title-group {
    display: block;
    padding: 0;
    height: 44px;
    line-height: 44px;
    margin-bottom: 12px;
    background-color: #fff;
    .left {
      float: left;
      width: 20%;
      margin-left: 11px;
      color: #5077aa;
      font-size: 16px;
      .iconfont {
        margin-right: 10px;
      }
    }
    h1 {
      float: left;
      width: 217px;
      text-align: center;
      font-size: 18px;
      color: #000;
    }
  }
}
::v-deep .cube-form_standard {
  .cube-form-item {
    min-height: 56px;
  }
  .cube-validator_invalid .cube-validator-msg:before {
    content: '';
  }
  .cube-validator-msg-def {
    margin-left: -4px;
    color: #f57676;
    font-size: 14px;
  }
}

::v-deep .cube-validator-content {
  line-height: 48px;
  font-size: 16px;
}
::v-deep .cube-validator-msg {
  align-items: center;
}
.date-time {
  display: flex;
  justify-content: space-between;
  &.fs-gray {
    color: #D6D6D6;
  }
  .iconfont {
    color: #d6d6d6;
  }
}
.texarea {
  display: block;
  ::v-deep .cube-form-label {
    width: auto;
    margin: 0 -15px;
    padding: 12px 15px 6px;
    color:#999;
    background-color: #f5f5f5;
  }

}
.cube-btn {
  width: 48%;
}
.isEnglish {
  .cube-picker-title-group .left {
    float: left;
  }
  .cube-picker-title-group h1 {
    float: none;
    font-size: 16px;
    width: auto;
  }
}
</style>
